import View from './view.js';
import icons from 'url:../../img/icons.svg';

class ShoppingListView extends View {
  _parentElement = document.querySelector(`.shopping-list__list`);
  _message = `No item on shopping list yet. Let's find something delicious :)`;
  _btnOpen = document.querySelector(`.nav__btn--shopping-list`);
  _window = document.querySelector(`.shopping-list-window`);
  _overlay = document.querySelector(`.overlay__add-shopping-list-window`);
  _btnClose = document.querySelector(`.btn--close-shopping-list`);

  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerCloseWindow(this.toggleWindow.bind(this));
  }

  toggleWindow() {
    this._window.classList.toggle(`hidden`);
    this._overlay.classList.toggle(`hidden`);
  }
  _addHandlerShowWindow() {
    this._btnOpen.addEventListener(`click`, this.toggleWindow.bind(this));
  }
  _addHandlerCloseWindow(handler) {
    this._btnClose.addEventListener(`click`, handler);
    this._overlay.addEventListener(`click`, handler);
    this._parentElement.addEventListener(`click`, function (e) {
      const item = e.target.closest(`.preview__link`);
      if (!item) return;
      handler();
    });
  }

  addhandlerRemoveRecipe(handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--remove-shopping-list`);
      if (!btn) return;
      handler(btn);
    });
  }

  _generateMarkup() {
    return this._data.map(this._generatePreview).join(``);
  }

  _generatePreview(recipe) {
    return `
    <li class="preview">
      <a class="preview__link" href="#${recipe.id}">
        <figure class="preview__fig">
          <img src="${recipe.imageUrl}" alt="${recipe.title}" />
        </figure>
        <div class="preview__data">
          <h4 class="preview__title">${recipe.title}</h4>
          <div class="preview__cookingTime">
          <svg class="preview__info-icon">
            <use href="${icons}#icon-clock"></use>
          </svg>
          <span>${recipe.cookingTime}</span>
          </div>
          <div class="preview__ing-num">
          <svg class="preview-icon">
            <use href="${icons}#icon-check"></use>
          </svg>
          <span>${recipe.ingNum}</span>
          </div>
          <p class="preview__publisher">${recipe.publisher}</p>
        </div>
      </a>
      <a class="btn btn--inline btn--remove-shopping-list"
        >X</a
      >
    </li>
    `;
  }

  getrecipeId(btn) {
    const recipe = btn.previousElementSibling;
    const id = recipe.getAttribute(`href`).slice(1);
    return id;
  }
}

export default new ShoppingListView();
